const translations = {
  MN: {
    profile: "Профайл",
    back: "Буцах",
    save: "Ажлын ярилцлага эхлүүлэх",
    saveOnly: "Хадгалах",
    saving: "Уншиж байна...",
    personalInfo: "Хувийн мэдээлэл",
    name: "Нэр",
    lastName: "Овог",
    email: "Имэйл",
    phone: "Утасны дугаар",
    gender: "Хүйс",
    regNumber: "Регистрийн дугаар",
    birthdate: "Төрсөн огноо",
    selectGender: "Хүйс сонгох",
    male: "Эрэгтэй",
    female: "Эмэгтэй",
    other: "Бусад",
    saveSuccess: "Профайл амжилттай хадгалагдлаа",
    saveError: "Профайл хадгалахад алдаа гарлаа",
    namePlaceholder: "Таны нэр",
    lastNamePlaceholder: "Таны овог",
    emailPlaceholder: "example@email.com",
    regNumberPlaceholder: "Регистрийн дугаар",
    year: "Он",
    month: "Сар",
    day: "Өдөр",
    selectYear: "Он",
    selectMonth: "Сар",
    selectDay: "Өдөр",
    months: ["1-р сар", "2-р сар", "3-р сар", "4-р сар", "5-р сар", "6-р сар", "7-р сар", "8-р сар", "9-р сар", "10-р сар", "11-р сар", "12-р сар"],
    changePhoto: "Зураг солих",
    uploadingPhoto: "Зураг хуулж байна...",
    photoUploadSuccess: "Зураг амжилттай хадгалагдлаа",
    photoUploadError: "Зураг хадгалахад алдаа гарлаа",
    photoSizeError: "Зураг 50MB-аас бага байх ёстой",
    photoTypeError: "Зөвхөн зураг файл оруулна уу",
    profilePhoto: "Профайл зураг",
    nameRequired: "Нэр оруулна уу",
    lastNameRequired: "Овог оруулна уу",
    photoRequired: "Профайл зураг оруулна уу",
    emailRequired: "Имэйл оруулна уу",
    birthdateRequired: "Төрсөн огноо оруулна уу",
    phoneRequired: "Утасны дугаар оруулна уу",
    genderRequired: "Хүйс сонгоно уу",
    regNumberRequired: "Регистрийн дугаар оруулна уу",
    exit: "Гарах",
  },
  UZ: {
    profile: "Profil",
    back: "Orqaga",
    save: "Ish suhbatini boshlash",
    saveOnly: "Saqlash",
    saving: "Yuklanmoqda...",
    personalInfo: "Shaxsiy ma'lumotlar",
    name: "Ism",
    lastName: "Familiya",
    email: "Email",
    phone: "Telefon raqami",
    gender: "Jins",
    regNumber: "Ro'yxatdan o'tish raqami",
    birthdate: "Tug'ilgan sana",
    selectGender: "Jinsni tanlang",
    male: "Erkak",
    female: "Ayol",
    other: "Boshqa",
    saveSuccess: "Profil muvaffaqiyatli saqlandi",
    saveError: "Profilni saqlashda xatolik",
    namePlaceholder: "Ismingiz",
    lastNamePlaceholder: "Familiyangiz",
    emailPlaceholder: "example@email.com",
    regNumberPlaceholder: "Ro'yxatdan o'tish raqami",
    year: "Yil",
    month: "Oy",
    day: "Kun",
    selectYear: "Yil",
    selectMonth: "Oy",
    selectDay: "Kun",
    months: ["Yanvar", "Fevral", "Mart", "Aprel", "May", "Iyun", "Iyul", "Avgust", "Sentabr", "Oktabr", "Noyabr", "Dekabr"],
    changePhoto: "Rasmni o'zgartirish",
    uploadingPhoto: "Rasm yuklanmoqda...",
    photoUploadSuccess: "Rasm muvaffaqiyatli yuklandi",
    photoUploadError: "Rasmni yuklashda xatolik",
    photoSizeError: "Rasm 50MB dan kichik bo'lishi kerak",
    photoTypeError: "Faqat rasm fayllarini yuklang",
    profilePhoto: "Profil rasmi",
    nameRequired: "Ismingizni kiriting",
    lastNameRequired: "Familiyangizni kiriting",
    photoRequired: "Profil rasmini yuklang",
    emailRequired: "Emailingizni kiriting",
    birthdateRequired: "Tug'ilgan sanani kiriting",
    phoneRequired: "Telefon raqamingizni kiriting",
    genderRequired: "Jinsingizni tanlang",
    exit: "Chiqish",
  },
  KZ: {
    profile: "Профиль",
    back: "Назад",
    save: "Начать собеседование",
    saveOnly: "Сохранить",
    saving: "Загрузка...",
    personalInfo: "Личная информация",
    name: "Имя",
    lastName: "Фамилия",
    email: "Электронная почта",
    phone: "Номер телефона",
    gender: "Пол",
    regNumber: "Регистрационный номер",
    birthdate: "Дата рождения",
    selectGender: "Выберите пол",
    male: "Мужской",
    female: "Женский",
    other: "Другой",
    saveSuccess: "Профиль успешно сохранен",
    saveError: "Ошибка при сохранении профиля",
    namePlaceholder: "Ваше имя",
    lastNamePlaceholder: "Ваша фамилия",
    emailPlaceholder: "example@email.com",
    regNumberPlaceholder: "Регистрационный номер",
    year: "Год",
    month: "Месяц",
    day: "День",
    selectYear: "Год",
    selectMonth: "Месяц",
    selectDay: "День",
    months: ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"],
    changePhoto: "Изменить фото",
    uploadingPhoto: "Загрузка фото...",
    photoUploadSuccess: "Фото успешно загружено",
    photoUploadError: "Ошибка при загрузке фото",
    photoSizeError: "Фото должно быть меньше 50MB",
    photoTypeError: "Разрешены только файлы изображений",
    profilePhoto: "Фото профиля",
    nameRequired: "Введите имя",
    lastNameRequired: "Введите фамилию",
    photoRequired: "Загрузите фото профиля",
    emailRequired: "Введите электронную почту",
    birthdateRequired: "Укажите дату рождения",
    phoneRequired: "Введите номер телефона",
    genderRequired: "Выберите пол",
    exit: "Выйти",
  },
};

export default translations;
